/* Boonsoir 2.0 — product page behaviour. Everything works without it; this only enhances. */
(() => {
  const mqDesktop = window.matchMedia('(min-width: 990px)');
  const mqMobile = window.matchMedia('(max-width: 749px)');

  function init(pdp) {
    if (!pdp || pdp.dataset.pdpReady) return;
    pdp.dataset.pdpReady = '1';
    const abort = new AbortController();
    const opt = { signal: abort.signal };
    pdp._abort = abort;

    /* ---------- Gallery: dots on the swipe strip ---------- */
    const track = pdp.querySelector('[data-pdp-track]');
    const dots = [...pdp.querySelectorAll('.pdp-gallery__dot')];
    if (track && dots.length && 'IntersectionObserver' in window) {
      const tiles = [...track.children];
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (en.intersectionRatio < 0.6) return;
          const i = tiles.indexOf(en.target);
          dots.forEach((d, n) => d.classList.toggle('is-on', n === i));
        });
      }, { root: track, threshold: 0.6 });
      tiles.forEach((t) => io.observe(t));
      pdp._io = io;
    }

    /* ---------- Sticky buy box that never hides its own bottom ---------- */
    const sticky = pdp.querySelector('[data-pdp-sticky]');
    if (sticky && 'ResizeObserver' in window) {
      const place = () => {
        if (!mqDesktop.matches) { sticky.style.removeProperty('--pdp-top'); return; }
        const headerH = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-h')) || 72;
        const ideal = headerH + 24;
        const h = sticky.offsetHeight;
        const top = h + ideal + 24 > window.innerHeight ? Math.min(ideal, window.innerHeight - h - 32) : ideal;
        sticky.style.setProperty('--pdp-top', `${Math.round(top)}px`);
      };
      const ro = new ResizeObserver(place);
      ro.observe(sticky);
      window.addEventListener('resize', place, opt);
      pdp._ro = ro;
    }

    /* ---------- Variant choice updates the visible price and the sticky bar ---------- */
    pdp.addEventListener('change', (e) => {
      const r = e.target.closest('.pdp-variant input, .pdp-size input');
      if (!r || !r.dataset.price) return;
      const price = pdp.querySelector('[data-pdp-price] .price span:last-child');
      if (price) price.textContent = r.dataset.price;
      const bar = pdp.querySelector('[data-pdp-bar-price]');
      if (bar) bar.textContent = r.dataset.price;
      const barSize = pdp.querySelector('[data-pdp-bar-size]');
      if (barSize) barSize.textContent = r.dataset.size || '';
    }, opt);

    /* ---------- Kies je formaat: the summary follows size × quantity ----------
       "€45,90 thuisbezorgd · incl. €5,95 verzending · nog €5,05 tot gratis verzending"
       and what the saving means. Server-rendered for quantity 1; this keeps it honest after that. */
    const sizes = pdp.querySelector('[data-pdp-sizes]');
    if (sizes) {
      const fmt = (window.Boonsoir && window.Boonsoir.moneyFormat) || '€{{amount_with_comma_separator}}';
      const eur = (cents) => {
        const n = Math.round(cents) / 100;
        return fmt
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, n.toFixed(2).replace('.', ','))
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(Math.round(n)))
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(n)))
          .replace(/\{\{\s*amount\s*\}\}/g, n.toFixed(2))
          .replace(/<[^>]+>/g, '').trim();
      };
      const form = sizes.closest('form');
      const totalEl = sizes.querySelector('[data-pdp-total]');
      const totalNote = sizes.querySelector('[data-pdp-total-note]');
      const note = sizes.querySelector('[data-pdp-note]');
      const summary = sizes.querySelector('[data-pdp-summary]');
      const threshold = parseInt(sizes.dataset.threshold, 10) || 0;
      const shipping = parseInt(sizes.dataset.shipping, 10) || 0;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let last = '';
      const sync = (silent) => {
        const r = sizes.querySelector('input:checked');
        if (!r || !totalEl) return;
        const qtyInput = form && form.querySelector('input[name="quantity"]');
        const qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
        const cents = parseInt(r.dataset.cents, 10) || 0;
        const total = cents * qty;
        const lead = qty > 1 ? `${qty} × ${r.dataset.size || ''} · ` : '';
        let totalText, noteText;
        if (threshold > 0 && total >= threshold) {
          totalText = `${lead}${eur(total)} thuisbezorgd`;
          noteText = 'verzending gratis';
        } else {
          totalText = `${lead}${eur(total + shipping)} thuisbezorgd`;
          noteText = `incl. ${eur(shipping)} verzending`;
          if (threshold > 0) noteText += ` · nog ${eur(threshold - total)} tot gratis verzending`;
        }
        const saving = (parseInt(r.dataset.saving, 10) || 0) * qty;
        const bags = (parseInt(r.dataset.bags, 10) || 1) * qty;
        const key = `${totalText}|${noteText}|${saving}`;
        if (key === last) return;
        last = key;
        totalEl.textContent = totalText;
        if (totalNote) totalNote.textContent = noteText;
        if (note) {
          if (saving > 0) {
            note.textContent = `Dat scheelt ${eur(saving)} tegenover ${bags} × 250 g. ${note.dataset.imageNote || ''}`.trim();
            note.hidden = false;
          } else {
            note.textContent = '';
            note.hidden = true;
          }
        }
        if (!silent && summary && summary.animate && !reduceMotion.matches) {
          summary.animate([{ opacity: .35 }, { opacity: 1 }], { duration: 360, easing: 'cubic-bezier(.2,0,0,1)' });
        }
      };
      pdp.addEventListener('change', (e) => {
        if (e.target.closest('.pdp-size input') || e.target.closest('input[name="quantity"]')) sync();
      }, opt);
      pdp.addEventListener('input', (e) => { if (e.target.closest('input[name="quantity"]')) sync(); }, opt);
      // Back/forward cache and autofill can restore another choice than the server rendered.
      sync(true);
    }

    /* ---------- "Maak het compleet": + becomes a tick for 2s after a successful add ---------- */
    document.addEventListener('cart:add:success', (e) => {
      const form = e.detail && e.detail.form;
      if (!form || !pdp.contains(form)) return;
      const btn = form.querySelector('.pdp-addon__add');
      if (!btn) return;
      btn.classList.add('is-added');
      clearTimeout(btn._added);
      if (btn._mo) btn._mo.disconnect();
      const later = () => { btn._added = setTimeout(() => btn.classList.remove('is-added'), 2000); };
      // The cart drawer usually opens on top: keep the tick until it has been seen for 2s.
      const drawer = document.querySelector('[data-cart-drawer]');
      if (drawer && drawer.classList.contains('is-open') && 'MutationObserver' in window) {
        btn._mo = new MutationObserver(() => {
          if (drawer.classList.contains('is-open')) return;
          btn._mo.disconnect(); btn._mo = null; later();
        });
        btn._mo.observe(drawer, { attributes: true, attributeFilter: ['class'] });
      } else later();
    }, opt);

    /* ---------- Quantity: the number rolls up (more) or down (fewer) ---------- */
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    pdp.querySelectorAll('.qty input').forEach((input) => { input._fxPrev = input.value; });
    pdp.addEventListener('focusin', (e) => { const i = e.target.closest('.qty input'); if (i) i._fxPrev = i.value; }, opt);
    pdp.addEventListener('change', (e) => {
      const input = e.target.closest('.qty input');
      if (!input) return;
      const before = input._fxPrev;
      input._fxPrev = input.value;
      if (before === undefined || before === input.value || reduce.matches || !input.animate) return;
      const dir = Number(input.value) > Number(before) ? 1 : -1;
      const wrap = input.closest('.qty');
      const ghost = document.createElement('span');
      ghost.className = 'pdp-qty-ghost';
      ghost.setAttribute('aria-hidden', 'true');
      ghost.textContent = before;
      Object.assign(ghost.style, { left: `${input.offsetLeft}px`, top: `${input.offsetTop}px`, width: `${input.offsetWidth}px`, height: `${input.offsetHeight}px` });
      wrap.appendChild(ghost);
      const o = { duration: 360, easing: 'cubic-bezier(.2,0,0,1)' };
      ghost.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: `translateY(${-12 * dir}px)` }], { ...o, fill: 'forwards' }).finished
        .then(() => ghost.remove()).catch(() => ghost.remove());
      input.animate([{ opacity: 0, transform: `translateY(${12 * dir}px)` }, { opacity: 1, transform: 'none' }], o);
    }, opt);

    /* ---------- Sticky mobile buy bar ---------- */
    const bar = pdp.querySelector('[data-pdp-bar]');
    const mainBtn = pdp.querySelector('[data-pdp-main-button]');
    if (bar && mainBtn) {
      let footerVisible = false;
      let frame = 0;
      const update = () => {
        frame = 0;
        // the bar stands in for the button whenever the button itself is off screen, above or below
        const rect = mainBtn.getBoundingClientRect();
        const buttonOff = rect.bottom < 0 || rect.top > window.innerHeight;
        const on = mqMobile.matches && buttonOff && !footerVisible && !pdp.classList.contains('is-closed');
        bar.classList.toggle('is-on', on);
        bar.inert = !on;
        if (on) bar.removeAttribute('aria-hidden'); else bar.setAttribute('aria-hidden', 'true');
      };
      const queue = () => { if (!frame) frame = requestAnimationFrame(update); };
      window.addEventListener('scroll', queue, { passive: true, signal: abort.signal });
      window.addEventListener('resize', queue, opt);
      const footer = document.querySelector('[data-site-footer], .site-footer, footer');
      if (footer && 'IntersectionObserver' in window) {
        const footIO = new IntersectionObserver(([en]) => { footerVisible = en.isIntersecting; queue(); });
        footIO.observe(footer);
        pdp._bar = [footIO];
      }
      mqMobile.addEventListener('change', queue, opt);
      update();
    }

    /* ---------- Package: live countdown + fresh stock state ---------- */
    const cd = pdp.querySelector('[data-pdp-countdown]');
    if (pdp.matches('.pdp--package')) {
      const deadline = cd ? Date.parse(cd.dataset.deadline) : NaN;
      let serverTime = cd ? Number(cd.dataset.serverNow) * 1000 : NaN;
      let anchor = performance.now();
      let closed = false;
      const now = () => serverTime + (performance.now() - anchor);

      const close = () => {
        closed = true;
        pdp.classList.add('is-closed');
        if (cd) { cd.classList.add('is-closed'); cd.textContent = 'De bestelronde is gesloten.'; }
        pdp.querySelectorAll('[data-package-stock]').forEach((el) => { el.textContent = 'De bestelronde is gesloten.'; });
        pdp.querySelectorAll('[data-package-form] button[type="submit"]').forEach((b) => { b.disabled = true; b.textContent = 'Bestelronde gesloten'; });
        pdp.querySelectorAll('.pdp-extras').forEach((f) => { f.disabled = true; });
        if (bar) { bar.classList.remove('is-on'); bar.inert = true; }
      };

      const tick = () => {
        if (!cd || !Number.isFinite(deadline) || !Number.isFinite(serverTime)) return;
        const remaining = deadline - now();
        if (remaining <= 0) { close(); return; }
        // Calm: days, then hours, then minutes. The seconds live on the home countdown only.
        const total = Math.floor(remaining / 1000);
        const d = Math.floor(total / 86400);
        const hrs = Math.floor(total / 3600);
        const mins = Math.floor(total / 60);
        let n, unit;
        if (d >= 1) { n = d; unit = d === 1 ? 'dag' : 'dagen'; }
        else if (hrs >= 1) { n = hrs; unit = 'uur'; }
        else { n = Math.max(1, mins); unit = n === 1 ? 'minuut' : 'minuten'; }
        const el = cd.querySelector('[data-cd="n"]');
        const v = String(n);
        if (el) {
          if (window.BoonsoirFX && window.BoonsoirFX.roll) window.BoonsoirFX.roll(el, v);
          else if (el.textContent !== v) el.textContent = v;
        }
        const name = cd.querySelector('[data-cd-name]');
        if (name && name.textContent !== unit) name.textContent = unit;
      };
      let timer;
      const schedule = () => {
        if (closed || !cd) return;
        const remaining = deadline - now();
        // next change: at the next minute boundary (or sooner near the deadline)
        const delay = Number.isFinite(remaining) && remaining > 0 ? Math.min(remaining, (remaining % 60000) + 50) : 1000;
        timer = setTimeout(() => { tick(); schedule(); }, delay);
      };
      tick(); schedule();

      // Block a submit that slips through after the deadline.
      pdp.addEventListener('submit', (e) => {
        if (!e.target.matches('[data-package-form]')) return;
        tick();
        if (closed) { e.preventDefault(); e.stopImmediatePropagation(); }
      }, { capture: true, signal: abort.signal });

      // Re-render the order state from Shopify (stock can change while the page is open).
      let refreshing = false;
      const refresh = async () => {
        const id = pdp.dataset.sectionId;
        if (refreshing || !id || !pdp.isConnected) return;
        refreshing = true;
        try {
          const url = new URL(location.href);
          url.searchParams.set('section_id', id);
          url.searchParams.set('_t', String(Date.now()));
          const res = await fetch(url, { cache: 'no-store', signal: abort.signal });
          if (!res.ok) return;
          const html = new DOMParser().parseFromString(await res.text(), 'text/html');
          const nextCd = html.querySelector('[data-pdp-countdown]');
          const t = nextCd ? Number(nextCd.dataset.serverNow) * 1000 : NaN;
          // Cached responses must never move the clock backwards.
          if (Number.isFinite(t) && t >= now()) { serverTime = t; anchor = performance.now(); }
          const current = pdp.querySelector('[data-package-state]');
          const next = html.querySelector('[data-package-state]');
          if (current && next && !current.contains(document.activeElement) && !current.querySelector('[aria-busy="true"]')) {
            const qty = current.querySelector('input[name="items[0][quantity]"]');
            const checked = [...current.querySelectorAll('.pdp-extra__box:checked')].map((b) => b.name);
            current.replaceWith(next);
            const q = next.querySelector('input[name="items[0][quantity]"]');
            if (q && qty) q.value = String(Math.max(1, Math.min(Number(q.max) || 99, Number(qty.value) || 1)));
            checked.forEach((name) => { const b = next.querySelector(`.pdp-extra__box[name="${name}"]`); if (b) b.checked = true; });
          }
          tick();
        } catch (err) { /* keep the server-rendered state when offline */ }
        finally { refreshing = false; }
      };
      document.addEventListener('cart:updated', refresh, opt);
      document.addEventListener('visibilitychange', () => { if (!document.hidden) { tick(); refresh(); } }, opt);
      const iv = setInterval(() => { if (!document.hidden) refresh(); }, 45000);
      pdp._timers = () => { clearTimeout(timer); clearInterval(iv); };
    }
  }

  function destroy(pdp) {
    if (!pdp) return;
    pdp._abort?.abort();
    pdp._io?.disconnect();
    pdp._ro?.disconnect();
    pdp._bar?.forEach((o) => o && o.disconnect());
    pdp._timers?.();
    delete pdp.dataset.pdpReady;
  }

  document.querySelectorAll('[data-pdp]').forEach(init);
  document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('[data-pdp]').forEach(init));
  document.addEventListener('shopify:section:unload', (e) => e.target.querySelectorAll('[data-pdp]').forEach(destroy));
})();
